import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"

import { useNetworksStateContext } from "../contexts/NetworksContext"

import { networksQueryKeys } from "./queryKeys"
import { useExtendWithSubnetworks } from "./useExtendWithSubnetworks"

export function useNetworkRoads(config = {}, subNetworks = null, module = null) {
    const { selectedNetwork } = useNetworksStateContext()

    const url = `/network/networks/${selectedNetwork.slug}/roads/`
    const parameters = useExtendWithSubnetworks(null, module, "sub_networks", subNetworks)

    const queryKey = networksQueryKeys.roads(selectedNetwork.slug, parameters)

    return useAuthenticatedQuery(
        url,
        queryKey,
        parameters,
        config,
    )
}